<template>
  <div>
    <div class=" row">
      <div class="avatar mr10" @click="goAgentShop">
        <img v-if="agentData.avatar" :src="agentData.avatar" class="all fillet" alt="">
        <img v-else :src="defaultAvatar" class="all fillet" alt="">
      </div>
      <div class="pl5 pt5">
        <div class="flex s_center">
          <h2 @click="goAgentShop" class="size20 bold">{{ agentData.trueName || '经纪人' }}</h2>
          <div class="departmentName ml20 size12">
            <!-- {{ agentData.departmentName || '名盛房产' }} -->
            {{ companyConfig.firstName + companyConfig.lastName }}
          </div>
        </div>
        <div class="size12 pt5" style="color:#CCCCCC">
          {{ agentData.manType == 2 ? '楼栋专家' : '好评经纪人' }}
        </div>
      </div>

    </div>
    <div class="mt20 flex">
      <el-button :style="tradeType == 1 ? 'width:200px;box-sizing: border-box;height:54px' : ''"
        class="tButton phoneButton greenBG size18 " :class="tradeType == 1 ? '' : 'flex1'"
        v-if="agentData.fixTel || agentData.mobile">
        <i class=" el-icon-phone"></i>
        {{ agentData.fixTel || agentData.mobile }}
      </el-button>
      <el-button :style="tradeType == 1 ? 'width:200px;box-sizing: border-box;height:54px' : ''"
        @click.stop="openChat(agentData)" plain class="tButton chatButton greenBG  green"
        :class="tradeType == 1 ? 'size18' : 'size16'">
        <i class=" el-icon-chat-dot-round "></i>
        在线问
      </el-button>
    </div>
  </div>
</template>
<script>
import Constant from "../common/Constant.js";
import { mapState } from "vuex";
import { EventBus } from '@/common/EventBus';
import SessionCache from '@/common/Session';
export default {
  name: "AgentData",
  props: {
    agentData: {
      type: Object,
      required: true,
    },
    tradeType: {
      default: 2,
    },
  },
  data() {
    return {
      defaultAvatar: Constant.DEFAULT_AVATAR,
    };
  },
  methods: {
    goAgentShop() {
      this.$router.push({
        path: "/agentShop",
        query: {
          guid: this.agentData.guid,
        },
      });
    },

    // 打开聊天窗口
    async openChat(agent) {
      if (this.user && this.user.account && this.user.account.guid) {
        const agentInfo = {
          agentAccountGuid: agent.accountGuid || agent.guid,
          agentName: agent.trueName || '经纪人',
          agentAvatar: agent.avatar || Constant.DEFAULT_AVATAR,
          agentGuid: agent.guid,
          agentMobile: agent.mobile || agent.fixTel,
          roles: 'agent',
          houseInfo: this.houseInfo,
          tradeType: this.tradeType,
          autoSendHouseCard: true
        };

        // 先检查IM是否已登录
        const imState = this.$store.state.im || {};

        if (!imState.isLogin || !imState.imInstans) {
          // 显示加载
          const loading = this.$loading({
            lock: true,
            text: '正在连接IM...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });

          try {
            const token = SessionCache.getAccessToken();
            const customerInfo = SessionCache.getCustomerInfo();

            if (!token || !customerInfo?.account?.guid) {
              loading.close();
              this.$store.commit("updateState", {
                data: true,
                key: "showLogin"
              });
              return;
            }

            // 初始化IM
            await this.$store.dispatch('im/initIM', {
              account: customerInfo.account.guid,
              token: token,
              callbackv2: () => {
                console.log('[IM] 初始化成功');
              }
            });

            // 等待连接稳定
            await new Promise(resolve => setTimeout(resolve, 1500));
            loading.close();

            // 继续执行聊天开启
            await this.startChatProcess(agentInfo);

          } catch (error) {
            loading.close();
            console.error('IM连接失败:', error);
            this.$message.error('连接IM失败，请刷新页面重试');
          }
        } else {
          // 已登录，直接开启聊天
          await this.startChatProcess(agentInfo);
        }
      } else {
        this.$store.commit("updateState", {
          data: true,
          key: "showLogin"
        });
      }
    },

    // 在 openChat 方法中，修改调用方式
    async startChatProcess(agentInfo) {
      const loading = this.$loading({
        lock: true,
        text: '正在开启聊天...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {

        // 关键：先尝试获取完整的好友列表
        const imState = this.$store.state.im || {};

        // 如果好友列表为空，先加载已有的好友
        if (!imState.friendslist || imState.friendslist.length === 0) {
          // 先重置并加载好友列表
          await this.$store.dispatch('im/resetAndLoadFriends');

          // 等待好友列表加载完成
          await new Promise(resolve => setTimeout(resolve, 500));
        }

        const success = await this.$store.dispatch('im/ensureFriendAndChat', agentInfo);

        if (success) {
          // 先打开聊天窗口
          EventBus.$emit('open-im-dialog', agentInfo);

          // 等待一下确保会话已创建
          await new Promise(resolve => setTimeout(resolve, 800));

          // 发送房源卡片
          if (this.houseInfo && Object.keys(this.houseInfo).length > 0) {

            const sent = await this.$store.dispatch('im/sendHouseCardAfterChat', {
              agentGuid: agentInfo.agentAccountGuid,
              houseInfo: this.houseInfo,
              tradeType: this.tradeType
            });

            if (sent) {
              // 发送成功后，主动切换当前会话，确保会话列表高亮
              await this.$store.dispatch('im/setCurrentSession', agentInfo.agentAccountGuid);
            } else {
              // 如果 sendHouseCardAfterChat 失败，尝试直接发送
              setTimeout(async () => {
                await this.$store.dispatch('im/sendHouseCardDirectly', {
                  fromGuid: this.$store.state.im.userGuid,
                  targetGuid: agentInfo.agentAccountGuid,
                  houseInfo: this.houseInfo,
                  tradeType: this.tradeType
                });
              }, 500);
            }
          }

          loading.close();
        } else {
          loading.close();
          this.$message.error('开启聊天失败，请重试');
        }
      } catch (error) {
        loading.close();
        console.error('开启聊天失败:', error);
        this.$message.error('开启聊天失败：' + (error.message || '未知错误'));
      }
    },
  },
  computed: {
    ...mapState(["isSourceERP", "companyConfig", "user"])
  },
};
</script>
<style scoped lang="less">
.avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.departmentName {
  padding: 0 3px;
  height: 24px;
  line-height: 24px;
  color: #889ebc;
  background-color: #f2f5f7;
  border-radius: 2px;
}

.tButton {
  color: #fff;
  border-radius: 1px;

  .i {
    color: #fff;
  }
}

.phoneButton:hover {
  background: #f0fef8;
  box-sizing: border-box;
  border: #00ae66 1px solid;
  color: #00ae66;

  .i {
    color: #00ae66;
  }
}

.chatButton {
  background: #f0fef8;
  border: #00ae66 1px solid;
  color: #00ae66;

  .i {
    color: #00ae66;
  }
}

.chatButton:hover {
  box-sizing: border-box;
  background: #fff;
  color: #00ae66;
  border: #00ae66 1px solid;

  .i {
    color: #00ae66;
  }
}
</style>